var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6499 32.6251C33.5841 32.7391 33.4894 32.8338 33.3753 32.8997C33.2613 32.9655 33.1319 33.0001 33.0002 33.0001H15.0002C14.8686 33 14.7394 32.9652 14.6255 32.8993C14.5116 32.8335 14.417 32.7388 14.3513 32.6248C14.2855 32.5108 14.2509 32.3815 14.251 32.2499C14.251 32.1183 14.2857 31.9891 14.3515 31.8751C15.7793 29.4067 17.9796 27.6367 20.5474 26.7976C19.2772 26.0415 18.2904 24.8893 17.7384 23.518C17.1865 22.1468 17.0999 20.6322 17.492 19.207C17.8841 17.7818 18.7333 16.5247 19.909 15.6287C21.0847 14.7328 22.522 14.2476 24.0002 14.2476C25.4784 14.2476 26.9157 14.7328 28.0914 15.6287C29.2672 16.5247 30.1163 17.7818 30.5084 19.207C30.9005 20.6322 30.8139 22.1468 30.262 23.518C29.71 24.8893 28.7232 26.0415 27.453 26.7976C30.0208 27.6367 32.2211 29.4067 33.649 31.8751C33.7149 31.989 33.7497 32.1183 33.7499 32.25C33.7501 32.3816 33.7156 32.511 33.6499 32.6251Z",
    fill: "#166534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/Gender.895a54a0704b273ef13f2530171ca9ee.svg";
export { ForwardRef as ReactComponent };